import React, { useState, useMemo, ChangeEvent } from 'react';
import * as antd from 'antd';
import * as ui from '@digital/ui';

import { hasPermission } from '@app/helpers/permissions';

import Narativa from '@app/components/Narativa';
import FiltrosPedidoComponent from '../FiltroPedido/FiltrosPedidoComponent';
import {
  CrfContratadoAno,
  CrfDistribuicao,
  getAllCrfContratoAno,
  obterNarativaPorCrfContaContabilCcRequisicaoCompraSeqId,
} from '@app/api/crf/crfContratoPcs';
import { getAllCrfProjetoContaContabilCc, ProjetoCrfContaContabilCc } from '@app/api/crf/crfProjeto';
import { Notifications } from '@app/api/api';

import {
  adicionarCrfLinhaItemRateavelPedido,
  atualizarValorCrfContratadoAnoPedido,
  concluirCrfRateioctPcmPedido,
  CrfPedidoFormulario,
  CrfPedidomaterialResult,
  deleteCrfDistribuicaoItemPedido,
  getFilterPedidoMateriais
} from '@app/api/crf/crfContratadoPcm';
import { isValidGuid } from '@app/helpers/generatorGuid';
import { ETipoFiltroContratado } from '@app/enums/ETipoFiltroContratado';

const PedidoMaterialIndex = () => {

  const [resultPesquisa, setResultConsult] = useState<CrfPedidomaterialResult[]>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [distribuicaoItemSelecionado, setdistribuicaoItemSelecionado] = useState<CrfContratadoAno>();
  const [resultContratadoAno, setResultContratadoAno] = useState<CrfContratadoAno[]>();
  const [resultDistribuicao, setDistribuicao] = useState<CrfDistribuicao>();
  const [selectionCrfContaContabilCc, setSelectionCrfContaContabilCc] = useState<string>();
  const [resultProjetoCrfContaContabilCc, setProjetoCrfContaContabilCc] = useState<ProjetoCrfContaContabilCc[]>();
  const [imputTextoNarativa, setImputTextoNarativa] = useState<string>('');
  const [imputProjeto, setImputProjeto] = useState<string>('');
  const [imputPacoteOi, setImputPacoteOi] = useState<string>('');
  const [editavel, setEditavel] = useState<boolean>(false);
  const [idEdit, setidEdit] = useState<string>('');
  const [quantidadeAnoEdit, setQuantidadeAnoEdit] = useState<string>('');
  const [enableBtnsRateio, setEnableBtnsRateio] = useState<boolean>(false);
  const [displayWidgetNovaLinha, setDisplayWidgetNovaLinha] = useState({ display: 'none' });
  const [displayWidgetResultado, setDisplayWidgetResultado] = useState({ display: 'none' });
  const [displayWidgetTabelaDistribuicao, setDisplayWidgetTabelaDistribuicao] = useState({ display: 'none' });
  const [btnAdicionarLinhaSelecionado, setBtnAdicionarLinhaSelecionada] = useState<boolean>(true);

  const rowSelection: any = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      if (selectedRows) {
        setResultadoSelecionado(selectedRowKeys[0]);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio'
  };

  const rowSelectionTableDistribuicao = {
    onChange: (selectedRowKeys: string, selectedRows: CrfContratadoAno[]) => {
      if (selectedRowKeys) {
        setdistribuicaoItemSelecionado(selectedRows[0]);
      } else {
        setdistribuicaoItemSelecionado({} as CrfContratadoAno);
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: distribuicaoItemSelecionado != undefined ? distribuicaoItemSelecionado.crfContaContabilCcRcSeqId : '',
    type: 'radio'
  };

  const rowSelectionCrfContaContabilCc = {
    onChange: (selectedRowKeys: any, selectedRows: ProjetoCrfContaContabilCc[]) => {
      if (selectedRows) {
        setSelectionCrfContaContabilCc(selectedRowKeys[0]);
      } else {
        setSelectionCrfContaContabilCc('');
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: selectionCrfContaContabilCc,
    type: 'radio'
  };

  const handleFilter = (values: CrfPedidoFormulario) => {
    getFilterPedidoMateriais(values).then((data: any) => {
      if (data && data.results) {
        limparCamposTela();
        setDisplayWidgetResultado({ display: 'block' });
        setResultConsult(data.results as CrfPedidomaterialResult[]);
        setdistribuicaoItemSelecionado({} as CrfContratadoAno);
      }
    });
  };

  const iniciarValores = () => {
    setResultContratadoAno([]);
    setdistribuicaoItemSelecionado({} as CrfContratadoAno);
    setDisplayWidgetNovaLinha({ display: 'none' });
    setEnableBtnsRateio(false);
    setImputTextoNarativa('');
    setDisplayWidgetTabelaDistribuicao({ display: 'none' });
    setBtnAdicionarLinhaSelecionada(false);
    setProjetoCrfContaContabilCc([]);
    setSelectionCrfContaContabilCc('');
  }

  const limparCamposTela = () => {
    setResultConsult([]);
    setResultadoSelecionado('');
    iniciarValores();
    setDisplayWidgetResultado({ display: 'none' });
  };


  const cancelar = () => {
    setEditavel(false);
    setidEdit('');
  };

  const eventoClickImput = (event: ChangeEvent<HTMLInputElement>, recorder: CrfContratadoAno, quantidadeAno: string) => {
    setEditavel(true);
    setidEdit(recorder.crfContaContabilCcRcSeqId);
    setQuantidadeAnoEdit(quantidadeAno);
  };

  const salvar = (
    recorder: CrfContratadoAno,
    event: ChangeEvent<HTMLInputElement>,
    quantidade: string,
    ano: string,
  ) => {
    atualizarValorCrfContratadoAnoPedido(
      recorder.moduloEconomicoContratadoId,
      recorder.crfContaContabilCcId,
      recorder.requisicaoCompraSeqId,
      quantidade,
      ano,
    ).then(data => {
      AtualizarTablelaContratoAno();
      setEditavel(false);
      setidEdit('');
    });
  };

  const columsDistribuicaoItem = useMemo(() => {
    const colluns: ui.ColumnProps<any>[] = [];

    colluns.push({
      title: 'CC / CONTA CONTÁBIL',
      key: 'PACOTE',
      children: [
        {
          title: 'CENTRO DE CUSTO',
          dataIndex: 'pacoteProjeto',
        },
        {
          title: 'CONTA CONTÁBIL',
          dataIndex: 'pacotePctOi',
        },
      ],
    });

    colluns.push({
      title: 'REQUISIÇÃO DE COMPRA',
      key: 'REQUISICAODECOMPRA',
      children: [
        {
          title: 'Numero',
          dataIndex: 'requisicaoCompraNumero',

        },
        {
          title: 'SEQ',
          dataIndex: 'requisicaoCompraSeq',

        },
        {
          title: 'PREÇO UNITÁRIO',
          dataIndex: 'requisicaoCompraPrecoUnitarioFormatado',

        },
        {
          title: 'QTD',
          dataIndex: 'quantidadeFormatado',

        },
        {
          title: 'VALOR',
          dataIndex: 'requisicaoCompraValorTotalFormatado',

        },
        {
          title: 'OC',
          dataIndex: 'requisicaoCompraOc',

        },
      ],
    });

    colluns.push({
      title: 'PEDIDO',
      key: 'PEDIDO',
      children: [
        {
          title: 'PCM',
          dataIndex: 'pedidoPcm',
        },
        {
          title: 'PREÇO UNITÁRIO',
          dataIndex: 'pedidoCtPreUnitarioFormatado',
        },
      ],
    });

    if (resultDistribuicao) {
      const distrubuicao = resultDistribuicao as CrfDistribuicao;
      let colunasAnos:
        {
          title: string;
          dataIndex: string;
          width: string;
          children: (
            {
              title: string;
              dataIndex: string; key:
              string; render: (text: any, record: any, index: any) => JSX.Element;
            } | { title: string; dataIndex: string; key: string; render?: undefined; })[];
        }[] = [];

      distrubuicao.anos.forEach(ano => {
        colunasAnos.push({
          title: `${ano}`,
          dataIndex: `${ano}`,
          width: '',
          children: [
            {
              title: 'QTD',
              dataIndex: `quantidade${ano}`,
              key: `quantidade${ano}`,
              render: (text, record, index) => {
                if (hasPermission(['MODULO_CONTRATADO_ALTERAR_INCLUIR_DELETAR'])) {
                  if (
                    editavel &&
                    idEdit === record.crfContaContabilCcRcSeqId &&
                    quantidadeAnoEdit === `${record.crfContaContabilCcRcSeqId}quantidade${ano}`
                  ) {
                    return (
                      <antd.Input
                        id={`${record.crfContaContabilCcRcSeqId}quantidade${ano}`}
                        name={`${record.crfContaContabilCcRcSeqId}quantidade${ano}`}
                        onBlur={() => {
                          cancelar();
                        }}
                        onPressEnter={e => {
                          const evento = e as unknown as ChangeEvent<HTMLInputElement>;
                          salvar(record, evento, record[`quantidade${ano}`], `${ano}`);
                        }}
                        defaultValue={record[`quantidadeInicial${ano}`]}
                        onChange={e => {
                          record[`quantidade${ano}`] = e.target.value;
                        }}
                      />
                    );
                  } else {
                    return (
                      <div
                        className="editable-cell-value-wrap"
                        style={{ paddingRight: 24 }}
                        onClick={e => {
                          const evento = e as unknown as ChangeEvent<HTMLInputElement>;
                          eventoClickImput(evento, record, `${record.crfContaContabilCcRcSeqId}quantidade${ano}`)
                        }}>
                        {<> {record[`quantidadeInicial${ano}`]} </>}
                      </div>
                    );
                  }

                } else {
                  return <> {record[`quantidadeInicial${ano}`]} </>
                }
              },
            },
            {
              title: 'Valor',
              dataIndex: `valorFormatado${ano}`,
              key: `valorFormatado${ano}`,
            },
          ],
        });
      });

      if (colunasAnos.length > 0) {
        colluns.push({
          title: 'RATEIO',
          key: 'RATEIO',
          children: colunasAnos[0].children,
        });
      }
    }

    return colluns;
  }, [resultDistribuicao, editavel, idEdit]);

  const columsRequisicaoCompraSeq = [
    {
      title: 'CC / CONTA CONTÁBIL',
      key: 'pacoteCodigo',
      children: [
        {
          title: 'N',
          dataIndex: 'row',
          width: '1%',
        },
        {
          title: 'Centro de Custo',
          dataIndex: 'projetoNumero',
          width: '',
        },
        {
          title: 'Conta Contábil',
          dataIndex: 'contaContabilCodigo',
          width: '',
        },
        {
          title: 'Título Conta Contábil',
          dataIndex: 'contaContabilNome',
          width: '',
        },
        {
          title: 'Agrupador',
          dataIndex: 'agrupador',
          width: '',
        },
        {
          title: 'Projeto',
          dataIndex: 'projetoNome',
          width: '',
        },
      ],
    },
    {
      title: 'RC',
      key: 'rc',
      children: [
        {
          title: 'NÚMERO	',
          dataIndex: 'rcNumero',
          width: '',
        },
        {
          title: 'SEQ',
          dataIndex: 'rcSeq',
          width: '',
        },
        {
          title: 'STATUS',
          dataIndex: 'rcStatus',
          width: '',
        },
      ],
    },
    {
      title: 'OC',
      key: 'oc',
      children: [
        {
          title: 'Numero',
          dataIndex: 'ocNumero',
          width: '',
        },
        {
          title: 'Data',
          dataIndex: 'ocData',
          width: '',
        },
      ],
    },
    {
      title: 'PEDIDO',
      key: 'PEDIDO',
      children: [
        {
          title: 'PCM',
          dataIndex: 'pedidoPcm',
          width: '',
        },
        {
          title: 'TIPO',
          dataIndex: 'pedidoTipo',
          width: '',
        },
        {
          title: 'FORNECEDOR',
          dataIndex: 'pedidoFornecedor',
          width: '',
        }
      ],
    },
  ];

  const columsNovasLinhas = [
    {
      title: 'PROJETO',
      dataIndex: 'numero',
      width: '10%',
    },
    {
      title: 'AGRUPADOR',
      dataIndex: 'codigoPacote',
      width: '10%',
    },
    {
      title: 'CONTA CONTÁBIL',
      dataIndex: 'crfContaContabilNumero',
      width: '10%',
    },
    {
      title: 'DESCRIÇÃO DA CONTA CONTÁBIL',
      dataIndex: 'nome',
    },
  ];

  const deletarLinhaRateio = async (crfContaContabilCcRcSeqId: string) => {

    if (!crfContaContabilCcRcSeqId || !isValidGuid(crfContaContabilCcRcSeqId)) {
      ui.notification.error('Você deve selecionar um centro de custo');
      return;
    }

    const result = await deleteCrfDistribuicaoItemPedido(crfContaContabilCcRcSeqId);
    if (result) {
      if (result.valid) {
        ui.notification.success('Item removido com sucesso.');
        AtualizarTablelaContratoAno();
      } else {
        if (result.invalid) {
          if (result.notifications.length > 0) {
            result.notifications.forEach(mensagem => {
              const mensagemNotificacao = mensagem as Notifications;
              ui.notification.error(mensagemNotificacao.message);
            })
          }
        }
      }
    }
  };

  const btnsDistribuicaoItem = useMemo(() => {
    const actions = [];

    if (hasPermission(['b6e77c08-2e7f-476c-9064-26ff3be7be6e'])) {
      actions.push(
        <ui.Button
          type="link"
          title="mostrar codigo"
          icon="data-add_column"
          onClick={() => {
            if (resultadoSelecionado) {
              alert(resultadoSelecionado)
            } else {
              ui.notification.error('Você deve selecionar um item');
            }
          }}
        />,
      );
    }

    if (hasPermission(['MODULO_CONTRATADO_ALTERAR_INCLUIR_DELETAR'])) {

      actions.push(
        <ui.ButtonDelete
          type="link"
          confirm="Deseja realmente excluir este registro?"
          title="EXCLUIR LINHA"
          icon="data-delete_row"
          okText="Confirmar"
          className="btn-delete-without-text"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (distribuicaoItemSelecionado) {
              deletarLinhaRateio(distribuicaoItemSelecionado.crfContaContabilCcRcSeqId);
            } else {
              ui.notification.error('Você deve selecionar um item');
            }
          }}
        />,
      );

      actions.push(
        <ui.Button
          type="link"
          title="ADICIONAR LINHA"
          icon="data-add_row"
          disabled={enableBtnsRateio}
          onClick={() => {
            setDisplayWidgetNovaLinha({ display: 'block' });
            setEnableBtnsRateio(true);
          }}
        />,
      );

      actions.push(
        <ui.Button type="primary"
          icon="messaging-ok"
          title="Concluir Rateio"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (resultadoSelecionado) {
              concluirCrfRateioctPcmPedido(resultadoSelecionado);
            } else {
              ui.notification.error('Você deve selecionar um item');
            }
          }} />);
    }

    return actions;
  }, [resultadoSelecionado, distribuicaoItemSelecionado, enableBtnsRateio]);

  const btnsNovaLinha = useMemo(() => {
    const actions = [];
    actions.push(
      <ui.Button
        type="link"
        title="Cancelar"
        icon="commons-cancel"
        onClick={() => {
          setEnableBtnsRateio(false);
          setProjetoCrfContaContabilCc([] as ProjetoCrfContaContabilCc[]);
          setDisplayWidgetNovaLinha({ display: 'none' });
        }}
      />,
    );

    actions.push(
      <ui.Button
        type="primary"
        title="Adicionar linha selecionada"
        disabled={btnAdicionarLinhaSelecionado}
        icon="data-add_row"
        onClick={() => {
          if (selectionCrfContaContabilCc && resultadoSelecionado) {
            adicionarCrfLinhaItemRateavelPedido(selectionCrfContaContabilCc, resultadoSelecionado).then(
              data => {
                AtualizarTablelaContratoAno();
              },
            );
          } else {
            ui.notification.error('Você deve selecionar um centro de custo');
          }
        }}
      />,
    );

    return actions;
  }, [resultadoSelecionado, btnAdicionarLinhaSelecionado, selectionCrfContaContabilCc]);

  const AtualizarTablelaContratoAno = () => {
    if (resultadoSelecionado) {
      getAllCrfContratoAno(resultadoSelecionado).then(data => {
        if (data) {
          const resultContratoAno = data as CrfDistribuicao;
          setDistribuicao(resultContratoAno);
          setResultContratadoAno(resultContratoAno.resultDataTabel);
          if (resultContratoAno.resultDataTabel.length > 0) {
            obterNaratinva(resultadoSelecionado);
          }
        }
      });
    }
  };

  const obterNaratinva = (crfContaContabilCcRcSeqId: string) => {
    obterNarativaPorCrfContaContabilCcRequisicaoCompraSeqId(crfContaContabilCcRcSeqId).then(data => {
      if (data)
        setImputTextoNarativa(data);
    });
  }

  const buscarDistribuicaoItem = () => {
    if (resultadoSelecionado) {
      getAllCrfContratoAno(resultadoSelecionado).then((data: any) => {
        if (data) {
          const resultContratoAno = data as CrfDistribuicao;
          setDistribuicao(resultContratoAno);
          setResultContratadoAno(resultContratoAno.resultDataTabel);
          setDisplayWidgetTabelaDistribuicao({ display: 'block' });
          if (resultContratoAno.resultDataTabel.length > 0) {
            obterNaratinva(resultadoSelecionado);
          }
        }
      });
    } else {
      ui.notification.error('Você deve selecionar um item');
    }
  };

  const handleChangeImputProjeto = (event: ChangeEvent<HTMLInputElement>) => {
    setImputProjeto(event.target.value);
  };

  const handleChangeImputPacoteOi = (event: ChangeEvent<HTMLInputElement>) => {
    setImputPacoteOi(event.target.value);
  };

  return (
    <ui.SimpleView>
      <ui.GridView noform>
        <FiltrosPedidoComponent
          onSearch={handleFilter}
          atualizarTela={limparCamposTela}
          tipoDoFiltro={ETipoFiltroContratado.PCM}
        />
        <ui.Widget
          title="RESULTADO"
          span={12}
          style={displayWidgetResultado}
          actions={[
            <ui.Button
              type="primary"
              title="VER DISTRIBUIÇÃO"
              icon="data-database"
              onClick={() => {
                buscarDistribuicaoItem();
              }}
            />,
          ]}>
          <ui.Table
            rowKey="crfContaContabilCcRcSeqId"
            id={'tabelaCrfDistribuicaoResultPcm'}
            columns={columsRequisicaoCompraSeq}
            dataSource={resultPesquisa && [].slice.call(resultPesquisa)}
            rowSelection={{
              ...rowSelection,
            }}
          />
        </ui.Widget>
        <ui.Widget
          title="DISTRIBUIÇÃO DO ITEM"
          actions={btnsDistribuicaoItem}
          style={displayWidgetTabelaDistribuicao}
        >

          <ui.MasterDetailForm initialValues={[]}>
            <Narativa textoNarativa={imputTextoNarativa} />
          </ui.MasterDetailForm>

          <ui.Table
            id={'tabelaDistribuicaoPcm'}
            rowKey="crfContaContabilCcRcSeqId"
            columns={columsDistribuicaoItem}
            pagination={false}
            dataSource={resultContratadoAno}
            rowSelection={{
              ...rowSelectionTableDistribuicao,
            }}
          />
          <ui.Widget
            title="INSERIR NOVAS LINHAS"
            className="inserir-novo-item"
            span={12}
            actions={btnsNovaLinha}
            style={displayWidgetNovaLinha}>
            <ui.MasterDetailForm initialValues={[]}>
              <ui.FormInput label="Nº Centro de Custo" name="projeto" span={2} allowClear onChange={handleChangeImputProjeto} />
              <ui.FormInput label="Código Conta Contábil" name="pacoteOi" span={2} allowClear onChange={handleChangeImputPacoteOi} />
              <ui.Button
                type="link"
                title="PESQUISAR"
                onClick={() => {
                  if (imputProjeto !== '' || imputPacoteOi !== '') {
                    getAllCrfProjetoContaContabilCc(imputProjeto, imputPacoteOi).then(data => {
                      setProjetoCrfContaContabilCc(data);
                      if (data && data.length > 0) {
                        setBtnAdicionarLinhaSelecionada(false);
                      } else {
                        setBtnAdicionarLinhaSelecionada(true);
                      }
                    });
                  } else {
                    ui.notification.error('Deve ser informado o  Centro de Custo ou Código Conta Contábil');
                  }
                }}
              />
            </ui.MasterDetailForm>

            <ui.Table
              rowKey="crfContaContabilCcId"
              columns={columsNovasLinhas}
              dataSource={resultProjetoCrfContaContabilCc}
              rowSelection={{
                ...rowSelectionCrfContaContabilCc,
              }}
            />
          </ui.Widget>
        </ui.Widget>
      </ui.GridView>
    </ui.SimpleView>
  );
};

export default PedidoMaterialIndex;
